// extracted by mini-css-extract-plugin
export default {"pagnationList":"pagnationComponet_pagnationList__y3RGq","pageNum":"pagnationComponet_pageNum__iqgR3"};